<template>
  <div class="v-data-footer">
    <v-row class="pt-5">
      <v-spacer></v-spacer>
      <v-col cols="4">
        <v-select
          v-model="actionSelected"
          :menu-props="{ offsetY: true }"
          outlined
          dense
          label="Akce"
          :items="actionTypes"
          item-text="name"
          item-value="value"
          data-cy="exportSelect"
        />
      </v-col>

      <v-col cols="auto">
        <v-btn
          :disabled="disabledActionButton"
          height="40"
          color="primary"
          :loading="loading"
          depressed
          @click="processAction($event)"
        >
          Provést
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { downloadFile } from '../mixins/downloadFile'
import { mapActions } from 'vuex'

export default {
  name: 'SupplierActionFooter',
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      actionSelected: null,
      loading: false,
    }
  },
  computed: {
    actionTypes() {
      return [
        {
          name: 'Zapnout vybrané dodavatele pro administrátory',
          value: 'enableForAdmin',
          disabled: !this.selectedIds.length,
        },
        {
          name: 'Vypnout vybrané dodavatele pro administrátory',
          value: 'disableForAdmin',
          disabled: !this.selectedIds.length,
        },
        {
          name: 'Zapnout vybrané dodavatele pro zákazníky',
          value: 'enableForClient',
          disabled: !this.selectedIds.length,
        },
        {
          name: 'Vypnout vybrané dodavatele pro zákazníky',
          value: 'disableForClient',
          disabled: !this.selectedIds.length,
        },
      ]
    },
    selectedIds() {
      return this.value.selectedData.items.map((item) => item.id)
    },
    disabledActionButton() {
      if (!this.actionSelected) {
        return true
      }
      if (this.actionSelected === 'enableForAdmin' && !this.selectedIds.length) {
        return true
      }
      if (this.actionSelected === 'disableForAdmin' && !this.selectedIds.length) {
        return true
      }
      if (this.actionSelected === 'enableForClient' && !this.selectedIds.length) {
        return true
      }
      if (this.actionSelected === 'disableForClient' && !this.selectedIds.length) {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapActions({
      updateSupplierVisibility: 'supplier/updateSupplierVisibility',
    }),
    // eslint-disable-next-line no-unused-vars
    processAction(event) {
      this.loading = true
      if (this.actionSelected === 'enableForAdmin') {
        this.processActionUpdate(true, true)
      } else if (this.actionSelected === 'disableForAdmin') {
        this.processActionUpdate(true, false)
      } else if (this.actionSelected === 'enableForClient') {
        this.processActionUpdate(false, true)
      } else if (this.actionSelected === 'disableForClient') {
        this.processActionUpdate(false, false)
      }
    },
    processActionUpdate(admin, enable) {
      const ids = this.value.selectedData.items.map((item) => item.id).join(',')

      this.updateSupplierVisibility({
        supplierIds: ids,
        admin: admin,
        enable: enable,
      }).finally(() => {
        this.actionSelected = null
        this.loading = false
        this.$emit('onVisibilityUpdate')
      })
    },
  },
}
</script>
